<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.show_adv") }}</h4>
    </div>
    <div class="col-12 text-end mb-3">
      <v-btn @click="$router.go(-1)" style="color: #f7941e">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Loading State -->
    <div v-if="loading" class="text-center py-5">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      <p class="mt-3">{{ $t("TABLES.loadingData") }}</p>
    </div>
    <!-- End:: Loading State -->

    <!-- Start:: Content -->
    <div v-else-if="data" class="single_step_form_content_wrapper">
      <div class="details-section">
        <!-- Ad Information Section -->
        <div class="section-wrapper mb-4">
          <h3 class="section-title mb-3">
            {{ $t("PLACEHOLDERS.order_data") }}
          </h3>
          <v-row>
            <v-col cols="12" md="6">
              <div class="detail-item">
                <strong>{{ $t("PLACEHOLDERS.ads_name") }}:</strong>
                <span>{{ data.name || $t("TABLES.noData") }}</span>
              </div>
            </v-col>

            <v-col cols="12" md="6" v-if="data.Hospitality">
              <div class="detail-item">
                <strong>{{ $t("PLACEHOLDERS.Hospitality") }}:</strong>
                <span>{{ data.Hospitality }}</span>
              </div>
            </v-col>

            <v-col cols="12" md="6">
              <div class="detail-item">
                <strong>{{ $t("PLACEHOLDERS.city") }}:</strong>
                <span>{{
                  data.city
                    ? getAppLocale === "ar"
                      ? data.city.name_ar
                      : data.city.name_en
                    : $t("TABLES.noData")
                }}</span>
              </div>
            </v-col>

            <!-- 4. عنوان الفرع (نصيًا) -->
            <v-col cols="12" md="6">
              <div class="detail-item">
                <strong>{{ $t("PLACEHOLDERS.address") }}:</strong>
                <span>{{ data.address || $t("TABLES.noData") }}</span>
              </div>
            </v-col>

            <!-- 10. الملاحظات الإضافية -->
            <v-col cols="12" v-if="data.notes">
              <div class="detail-item">
                <strong>{{ $t("PLACEHOLDERS.note") }}:</strong>
                <span>{{ data.notes }}</span>
              </div>
            </v-col>
          </v-row>
        </div>

        <!-- 6. أيام الإعلان و 7. الوقت (من – إلى) -->
        <div
          class="section-wrapper mb-4"
          v-if="data.dates && data.dates.length"
        >
          <h3 class="section-title mb-3">{{ $t("PLACEHOLDERS.dates") }}</h3>
          <v-row>
            <v-col cols="12">
              <div
                v-for="(date, index) in data.dates"
                :key="index"
                class="date-item mb-2"
              >
                <span
                  >{{ formatDate(date.start_at) }}
                  {{ $t("PLACEHOLDERS.from") }}
                  {{ formatTime(date.start_at) }} إلى
                  {{ formatTime(date.end_at) }}</span
                >
              </div>
            </v-col>
          </v-row>
        </div>

        <!-- 8. صورة المكان -->
        <div
          class="section-wrapper mb-4"
          v-if="data.images && data.images.length"
        >
          <h3 class="section-title mb-3">
            {{ $t("PLACEHOLDERS.imagesefed") }}
          </h3>
          <v-row>
            <v-col
              cols="12"
              md="4"
              v-for="(image, index) in data.images"
              :key="index"
            >
              <img :src="image" class="ad-image" alt="Ad Image" />
            </v-col>
          </v-row>
        </div>

        <!-- 5. الموقع على الخريطة -->
        <div class="section-wrapper mb-4">
          <h3 class="section-title mb-3">{{ $t("PLACEHOLDERS.location") }}</h3>
          <v-row>
            <v-col cols="12">
              <div class="map-container" v-if="data.lat && data.lng">
                <iframe
                  :src="`https://maps.google.com/maps?q=${data.lat},${data.lng}&z=15&output=embed`"
                  width="100%"
                  height="400"
                  frameborder="0"
                  style="border: 0"
                ></iframe>
              </div>
              <p v-else class="text-danger">{{ $t("TABLES.noData") }}</p>
            </v-col>
          </v-row>
        </div>

        <!-- Package and Payment Section -->
        <div class="section-wrapper mb-4">
          <h3 class="section-title mb-3">{{ $t("PLACEHOLDERS.priceData") }}</h3>
          <v-row>
            <v-col cols="12" md="6">
              <div class="detail-item">
                <strong>{{ $t("PLACEHOLDERS.number_of_people") }}:</strong>
                <span>{{ data.guests_number || $t("TABLES.noData") }}</span>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="detail-item">
                <strong>{{ $t("PLACEHOLDERS.package_name") }}:</strong>
                <span>{{
                  data.package ? data.package.name : $t("TABLES.noData")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="detail-item">
                <strong>{{ $t("PLACEHOLDERS.package_price") }}:</strong>
                <span
                  >{{ data.package_price || "0" }}
                  {{ $t("PLACEHOLDERS.sar") }}</span
                >
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="detail-item">
                <strong>{{ $t("PLACEHOLDERS.tax") }}:</strong>
                <span
                  >{{ data.tax_in_value || "0" }}
                  {{ $t("PLACEHOLDERS.sar") }}</span
                >
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="detail-item">
                <strong>{{ $t("PLACEHOLDERS.total_price") }}:</strong>
                <span class="text-primary font-weight-bold"
                  >{{ calculateTotal(data.package_price, data.tax_in_value) }}
                  {{ $t("PLACEHOLDERS.sar") }}</span
                >
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="detail-item">
                <strong>{{ $t("PLACEHOLDERS.transaction_id") }}:</strong>
                <span>{{ data.transaction_id || $t("TABLES.noData") }}</span>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="detail-item">
                <strong>{{ $t("PLACEHOLDERS.payemnt_status") }}:</strong>
                <span
                  class="badge"
                  :class="{
                    'badge-success': data.payemnt_status === 'successed',
                    'badge-danger': data.payemnt_status === 'failed',
                    'badge-info': data.payemnt_status === 'refunded',
                  }"
                  v-if="data.payemnt_status"
                >
                  {{ data.payemnt_status }}
                </span>
                <span v-else>{{ $t("TABLES.noData") }}</span>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="detail-item">
                <strong>{{ $t("PLACEHOLDERS.created_at") }}:</strong>
                <span>{{
                  data.payed_at
                    ? formatDate(data.payed_at)
                    : $t("TABLES.noData")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="detail-item">
                <strong>{{ $t("PLACEHOLDERS.payment_method") }}:</strong>
                <span>{{ data.payemnt_method }}</span>
              </div>
            </v-col>
          </v-row>
        </div>

        <!-- Engagement Metrics Section -->
        <div class="section-wrapper mb-4">
          <h3 class="section-title mb-3">{{ $t("PLACEHOLDERS.rating") }}</h3>
          <v-row>
            <v-col cols="12" md="4">
              <div class="stat-card">
                <div class="stat-icon">
                  <i class="fas fa-users"></i>
                </div>
                <div class="stat-content">
                  <h4>{{ data.guests_number ? data.guests_number : 0 }}</h4>
                  <p>{{ $t("PLACEHOLDERS.number_of_people") }}</p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="stat-card">
                <div class="stat-icon">
                  <i class="fas fa-user-check"></i>
                </div>
                <div class="stat-content">
                  <h4>{{ data.announcement_users ?? 0 }}</h4>
                  <p>{{ $t("PLACEHOLDERS.actual_number") }}</p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="stat-card">
                <div class="stat-icon">
                  <i class="fas fa-chart-line"></i>
                </div>
                <div class="stat-content">
                  <h4>{{ data.attendance_percantage || 0 }}</h4>
                  <p>{{ $t("PLACEHOLDERS.percentage_on_booking") }}</p>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
    <!-- End:: Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ShowAds",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  data() {
    return {
      // Start:: Loader Control Data
      loading: false,
      // End:: Loader Control Data

      // Start:: Data
      data: null,
      // End:: Data
    };
  },

  methods: {
    // Start:: Get Announcement Data
    async getAdsData() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `announcements/${this.$route.params.id}`,
        });
        this.loading = false;
        this.data = res.data.data.Announcement;
      } catch (error) {
        this.loading = false;
        this.$message.error(
          error.response?.data?.message || this.$t("TABLES.loadingData")
        );
        console.log(error.response?.data?.message);
      }
    },
    // End:: Get Announcement Data

    // Start:: Helper Methods
    formatDate(dateString) {
      if (!dateString) return this.$t("TABLES.noData");
      const date = new Date(dateString);
      return date.toLocaleDateString("ar-SA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },

    formatTime(dateString) {
      if (!dateString) return this.$t("TABLES.noData");
      const date = new Date(dateString);
      return date.toLocaleTimeString("ar-SA", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: "Africa/Cairo",
      });
    },

    calculateTotal(price, tax) {
      const priceNum = parseFloat(price) || 0;
      const taxNum = parseFloat(tax) || 0;
      return (priceNum + taxNum).toFixed(2);
    },

    calculateActualAttendance(ad) {
      if (ad.attendance_percantage && ad.guests_number) {
        return Math.round((ad.attendance_percantage / 100) * ad.guests_number);
      }
      return 0;
    },

    getAdStatusText(status) {
      const statuses = {
        published: this.$t("STATUS.published"),
        expired: this.$t("STATUS.done"),
        payment_failed: this.$t("STATUS.canceled"),
        stopped_by_admin: this.$t("STATUS.rejected"),
      };
      return statuses[status] || status || this.$t("TABLES.noData");
    },

    getPaymentStatusText(status) {
      const statuses = {
        successed: this.$t("STATUS.approved"),
        failed: this.$t("STATUS.rejected"),
        refunded: this.$t("STATUS.canceled"),
      };
      return statuses[status] || status || this.$t("TABLES.noData");
    },

    getPaymentMethodText(method) {
      const methods = {
        online: this.$t("STATUS.online"),
        cash: this.$t("STATUS.cash"),
        wallet: this.$t("PLACEHOLDERS.wallet"),
      };
      return methods[method] || method || this.$t("TABLES.noData");
    },
    // End:: Helper Methods
  },

  created() {
    // Start:: Fire Methods
    this.getAdsData();
    // End:: Fire Methods
  },
};
</script>

<style lang="scss" scoped>
.details-section {
  .section-wrapper {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .section-title {
    color: #f7941e;
    font-weight: bold;
    border-bottom: 2px solid #f7941e;
    padding-bottom: 8px;
    margin-bottom: 15px;
  }

  .detail-item {
    padding: 12px 0;
    border-bottom: 1px solid #eee;

    &:last-child {
      border-bottom: none;
    }

    strong {
      display: inline-block;
      min-width: 180px;
      color: #333;
      margin-left: 10px;
      font-weight: 600;
    }

    span {
      color: #666;
    }
  }

  .date-item {
    padding: 12px 15px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 8px;
    margin-bottom: 10px;
    border-left: 4px solid #f7941e;

    strong {
      color: #f7941e;
      margin-left: 10px;
    }
  }

  .ad-image {
    width: 100%;
    height: 250px;
    object-fit: cover;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.02);
    }
  }

  .map-container {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .stat-card {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 12px;
    padding: 20px;
    display: flex;
    align-items: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    .stat-icon {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background: linear-gradient(135deg, #f7941e 0%, #ff8c00 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 15px;

      i {
        font-size: 24px;
        color: white;
      }
    }

    .stat-content {
      flex: 1;

      h4 {
        font-size: 28px;
        font-weight: bold;
        color: #f7941e;
        margin: 0;
      }

      p {
        margin: 5px 0 0 0;
        color: #666;
        font-size: 14px;
      }
    }
  }
}

.badge {
  padding: 6px 14px;
  border-radius: 6px;
  color: white;
  font-weight: bold;
  display: inline-block;
  font-size: 13px;
}

.badge-success {
  background-color: #28a745;
}

.badge-danger {
  background-color: #dc3545;
}

.badge-warning {
  background-color: #ffc107;
  color: #000;
}

.badge-info {
  background-color: #17a2b8;
}

.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 8px;
}
</style>
